export default __webpack_public_path__ + "static/media/En_aprobación.d66909be.svg";